import type {
  PreparedSurveyAnswer,
  SurveySession,
} from "../../../session/SurveySession";
import type { Question } from "../../../util/types";
import {
  activeQuestionGroupChild,
  isQuestionGroupContainerRaw,
  questionGroupChildRaw,
} from "../../questionGroup/core";
import { questionRegistry } from "../../registry";
import type { AttemptDraftState } from "../types";
import { groupDraftValue } from "./draftState";
import type { SurveyCopy } from "../../../theme/copy";
import { defaultThemeV2 } from "../../../theme/defaultThemeV2";

export const prepareGroupAnswer = (
  question: Question,
  state: AttemptDraftState | null | undefined,
  session: SurveySession,
  copy: SurveyCopy = defaultThemeV2.copy,
): PreparedSurveyAnswer | null => {
  const raw = question.question;
  /* v8 ignore next -- the session only invokes this resolver for the same group */
  if (!isQuestionGroupContainerRaw(raw)) return null;
  const child = activeQuestionGroupChild(raw);
  /* v8 ignore next -- malformed active IDs are rejected by the group decoder */
  if (!child || child.answered) return null;
  const module = questionRegistry.get(child.question.type);
  /* v8 ignore next -- group child modules are checked by supportsSurveyQuestion */
  if (!module) return null;
  const childRaw = questionGroupChildRaw(child);
  const definition = module.core.decode(childRaw);
  const draft = groupDraftValue(
    state,
    session,
    `group:${raw.group_id}`,
    child,
    module,
    definition,
  );
  const validation = module.core.validate(definition, draft, copy);
  /* v8 ignore next -- the Forms submit button requires every pending draft to validate */
  if (!validation.valid) return null;
  return {
    answer: module.core.encode(definition, draft),
    projection: module.core.projectTranscript(definition, draft, copy),
  };
};
